module.exports = __webpack_public_path__ + "img/8.51d495e4.png";